/**
 * Asynchronously loads the component for RemittanceAdvice
 */

import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const RemittanceAdvice = lazyLoad(
    () => import('./index'),
    module => module.RemittanceAdvice,
    { fallback: <LoadingSpinner /> },
);
